import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-picker',
  template: require('./date-picker.component.html'),
  styles: [require('./date-picker.component.sass')]
})
export class DatePickerComponent implements OnInit, OnChanges {
  
  @Input() date: string | number | Date; 
  @Input() maxDate: string | number | Date;
  @Input() minDate: string | number | Date;
  @Output() change = new EventEmitter<any>();

  currentDate: NgbDateStruct;
  currentMaxDate: NgbDateStruct;
  currentMinDate: NgbDateStruct;

  constructor() { }

  ngOnInit(): void {
    this.updateDateValues(this.date, this.maxDate, this.minDate)
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.updateDateValues(changes.date && changes.date.currentValue , 
        changes.maxDate && changes.maxDate.currentValue, 
        changes.minDate && changes.minDate.currentValue)
    }
  }

  updateDateValues = (newDate, newMaxDate, newMinDate) => {
    if (newDate) {
      const inputDate = new Date(newDate)
      this.currentDate = {
        day: inputDate.getDate(),
        month: inputDate.getMonth() + 1,
        year: inputDate.getFullYear()
      }
    }

    if (newMaxDate) {
      const maxDate = new Date(newMaxDate)
      this.currentMaxDate = {
        day: maxDate.getDate(),
        month: maxDate.getMonth() + 1,
        year: maxDate.getFullYear()
      }
    }

    if (newMinDate) {
      const minDate = new Date(newMinDate)
      this.currentMinDate = {
        day: minDate.getDate(),
        month: minDate.getMonth() + 1,
        year: minDate.getFullYear()
      }
    }
  }
  

  onDateSelect(newDate: NgbDateStruct){
    if (newDate) {
      this.change.emit(new Date(`${newDate.year}-${newDate.month}-${newDate.day}`))
    }
  }

}
